import i18n, { use } from 'i18next'
import { initReactI18next } from 'react-i18next'

import { LANGUAGES_ENUM } from 'shared/utils/constants'

const PRODUCT_KEY = 'edubookNewPublic'
const supportedLngs = Object.values(LANGUAGES_ENUM)
const STORAGE = 'PUBIC_LOCALES'

const applyResources = (resources) => {
  Object.entries(resources).forEach(([lng, data]) => {
    i18n.addResourceBundle(lng, 'translation', data, true, true)
  })
}

const fetchIndex = async () => {
  const controller = new AbortController()
  const timeoutId = setTimeout(() => controller.abort(), 5000)

  try {
    const response = await fetch(`${window.origin}/locales/index.json`, {
      cache: 'no-store',
      signal: controller.signal,
    })
    clearTimeout(timeoutId)
    if (!response.ok && response.status !== 304) return null

    const data = await response.json()
    const def = data?.[PRODUCT_KEY]

    return { id: def?.id }
  } catch (error) {
    console.info(error)
    return null
  } finally {
    clearTimeout(timeoutId)
  }
}

const fetchLocalBundle = async (languages) => {
  try {
    const entries = await Promise.all(
      languages.map(async (lng) => {
        const response = await fetch(`/public/locales/${lng}.json`, {
          cache: 'no-cache',
        })

        if (!response.ok) {
          throw new Error(`Failed to fetch ${lng} local bundle`)
        }

        return [lng, await response.json()]
      }),
    )

    return { resources: Object.fromEntries(entries) }
  } catch (error) {
    console.info(error)
    return null
  }
}

const fetchBundle = async (bundleId, project) => {
  const baseUrl = `${window.origin}/locales`

  try {
    const entries = await Promise.all(
      supportedLngs.map(async (lng) => {
        const response = await fetch(
          `${baseUrl}/${project}/${bundleId}/${lng}.json`,
          {
            cache: 'no-cache',
          },
        )

        if (
          !response.ok ||
          !response.headers.get('content-type')?.includes('application/json')
        ) {
          throw new Error(`Respuesta inválida para ${lng}: ${response.status}`)
        }

        return [lng, await response.json()]
      }),
    )

    return { resources: Object.fromEntries(entries) }
  } catch (error) {
    console.info(error)
    return null
  }
}

const getResources = async () => {
  const remoteMeta = await fetchIndex()
  const serialized = localStorage.getItem(STORAGE) ?? ''
  const localStorageResources = serialized && JSON.parse(serialized)

  if (
    (remoteMeta && !localStorageResources) ||
    localStorageResources.id !== remoteMeta?.id
  ) {
    const remoteResources = await fetchBundle(remoteMeta.id, PRODUCT_KEY)
    localStorage.setItem(
      STORAGE,
      JSON.stringify({
        id: remoteMeta.id,
        resources: remoteResources?.resources,
      }),
    )

    return remoteResources?.resources
  }
  if (localStorageResources) {
    return localStorageResources.resources
  }
  return {}
}

use(initReactI18next).init({
  debug: false,
  fallbackLng: LANGUAGES_ENUM?.ES_ES,
  initImmediate: false,
  interpolation: {
    escapeValue: false,
    formatSeparator: ',',
  },
  lng: 'es_ES',
  nsSeparator: false,
  react: {
    useSuspense: false,
  },
  requestOptions: {
    cache: 'no-cache',
  },
  supportedLngs,
})

getResources()
  .then((resources) => resources ?? fetchLocalBundle(supportedLngs))
  .then((resources) => applyResources(resources || {}))
  .catch((error) => console.info(error))

export default i18n

// applyResources(resources)
